import React, { useState } from "react";
import GoalCard from "./GoalCard";

const GoalList = ({ goals, loading, filters, onFilterChange, onGoalDeleted, onGoalUpdated }) => {
    const [editingGoal, setEditingGoal] = useState(null);

    const handleFilterChange = (filterType, value) => {
        onFilterChange({
            ...filters,
            [filterType]: value
        });
    };

    const clearFilters = () => {
        onFilterChange({
            category: "",
            priority: "",
            completed: ""
        });
    };

    const getUniqueCategories = () => {
        const categories = goals
            .map((goal) => goal.category)
            .filter(Boolean)
            .filter((category, index, list) => list.indexOf(category) === index);
        return categories;
    };

    const hasActiveFilters = Object.values(filters).some((filter) => filter !== "");

    return (
        <section className="workspace-card goal-feed" id="goal-feed">
            <header className="goal-feed__header">
                <div className="goal-feed__title-row">
                    <h2 className="goal-feed__title">成就时间线</h2>
                    <span className="goal-feed__count">共 {goals.length} 条</span>
                </div>
                <div className="goal-feed__filters">
                    <select
                        className="goal-feed__select"
                        value={filters.priority}
                        onChange={(event) => handleFilterChange("priority", event.target.value)}
                    >
                        <option value="">全部优先级</option>
                        <option value="high">高优先级</option>
                        <option value="medium">中优先级</option>
                        <option value="low">低优先级</option>
                    </select>

                    <select
                        className="goal-feed__select"
                        value={filters.category}
                        onChange={(event) => handleFilterChange("category", event.target.value)}
                    >
                        <option value="">全部分类</option>
                        {getUniqueCategories().map((category) => (
                            <option key={category} value={category}>
                                {category}
                            </option>
                        ))}
                    </select>

                    {hasActiveFilters && (
                        <button type="button" className="goal-feed__reset" onClick={clearFilters}>
                            清除筛选
                        </button>
                    )}
                </div>
            </header>

            {loading ? (
                <div className="goal-feed__loading">
                    <div className="loading-spinner" />
                    <span>加载成就中...</span>
                </div>
            ) : goals.length === 0 ? (
                <div className="goal-feed__empty">
                    <span role="img" aria-label="target">🎯</span>
                    <p>
                        {hasActiveFilters
                            ? "当前筛选条件下没有记录，尝试清除筛选。"
                            : "还没有新的成果，先来记录你的第一个里程碑吧！"}
                    </p>
                    {hasActiveFilters && (
                        <button type="button" className="btn secondary" onClick={clearFilters}>
                            清除筛选
                        </button>
                    )}
                </div>
            ) : (
                <div className="goal-feed__content">
                    {goals.map((goal) => (
                        <GoalCard
                            key={goal.id}
                            goal={goal}
                            isEditing={editingGoal === goal.id}
                            onEdit={() => setEditingGoal(goal.id)}
                            onCancelEdit={() => setEditingGoal(null)}
                            onDelete={() => onGoalDeleted(goal.id)}
                            onUpdate={(updatedGoal) => {
                                onGoalUpdated(updatedGoal);
                                setEditingGoal(null);
                            }}
                        />
                    ))}
                </div>
            )}
        </section>
    );
};

export default GoalList;
